import React from 'react';
import { Box, Grid, CardContent, Card, Chip } from '@mui/material';
import PropTypes from 'prop-types';
import './seccionPreview.scss';

export default function SeccionPreviewRol({ roles }) {

    function ItemR(props) {
        const { sx, ...other } = props;
        return (
            <Box
                sx={{
                    bgcolor: (theme) => (theme.palette.mode === 'dark' ? '#101010' : '#fff'),
                    color: (theme) => (theme.palette.mode === 'dark' ? 'grey.300' : 'grey.800'),
                    borderRadius: 0,
                    fontSize: '0.75rem',
                    ...sx,
                    padding: 1
                }}
                {...other}
            />
        );
    }

    ItemR.propTypes = {
        sx: PropTypes.oneOfType([
            PropTypes.arrayOf(
                PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool]),
            ),
            PropTypes.func,
            PropTypes.object,
        ]),
    };

    return (
        <Card sx={{ width: '100%', marginTop: '30px' }} elevation={0}>
            <CardContent>
                <strong>
                    Roles
                </strong>
                <div className='seccion-container'>
                    {
                        Array.isArray(roles) && roles.length > 0 ? (
                            roles.map((rol, index) => (
                                <Chip key={index} label={rol.descripcion} className='chip-preview' />
                            ))
                        ) : (
                            <span>No hay roles disponibles</span>
                        )
                    }
                </div>
            </CardContent>
        </Card>
    )

};